﻿import React, {FC} from 'react';
import {SupplierActivitySummaryVo} from "../../../types/supplier/SupplierActivitySummaryVo";
import {SupplierActivitySummariesGroupedLoader} from "./SupplierActivitySummariesGroupedLoader";
import {withLoader} from "../../hocs/withLoader";
import {
  GroupSummariesCardContainer,
  GroupSummariesCardItem,
  GroupSummariesCardFullScreen
} from "../../cardComponents";

interface SupplierActivitySummariesGroupedProps {
  aggregatedSummaries?: SupplierActivitySummaryVo;
}

/**
 * Component to display aggregated values for grouped SupplierActivitySummaries
 * @param aggregatedSummaries the aggregated values/labels to display
 * @constructor
 */
const SupplierActivitySummariesGrouped: FC<SupplierActivitySummariesGroupedProps> = ({ aggregatedSummaries }) => {
  return <GroupSummariesCardFullScreen>
    <GroupSummariesCardContainer>
      <GroupSummariesCardItem title={'Location'} value={aggregatedSummaries?.location} />
      <GroupSummariesCardItem title={'Current Inventory'} value={aggregatedSummaries?.currentInventory} />
      <GroupSummariesCardItem title={'Max Inventory'} value={aggregatedSummaries?.maxInventory} />
      <GroupSummariesCardItem title={'Capacity'} value={aggregatedSummaries?.capacity} />
      <GroupSummariesCardItem title={'Max Capacity'} value={aggregatedSummaries?.maxCapacity} />
      <GroupSummariesCardItem title={'Booked Spaces'} value={aggregatedSummaries?.bookedSpaces ?? 0} />
    </GroupSummariesCardContainer>
  </GroupSummariesCardFullScreen>
}

const SupplierActivitySummariesGroupedWithLoader = withLoader(SupplierActivitySummariesGrouped, SupplierActivitySummariesGroupedLoader);

export { SupplierActivitySummariesGroupedWithLoader };
